import React from "react";

import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import styled from "styled-components";

import { colors } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

import Title from "../Title";

import iconCancel from "../../../assets/images/icons/cross.svg";
import backIcon from "../../../assets/images/icons/arrow-left-straight.svg";

/* The notch zone above this header is painted by Layout's TopInsetSpacer
 * (or the parent tray's padding-top: env(...)). The header itself just
 * uses plain padding values; the back button is centred on top: 50%. */
const StyledTasteChallengeHeader = styled.header`
  background-color: ${colors.white};
  padding: 20px 15px;
  position: relative;
  text-align: center;
  width: 100%;
`;

const TasteChallengeHeaderBtnBack = styled.button`
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-block;
  width: 30px;
  height: 16px;
  background: url("${(props) => props.closeIcon}") no-repeat 50% 50% / contain;
  ${breakpoints.smUp} {
    left: 25px;
    width: 30px;
    height: 30px;
    background: url("${(props) => props.closeIcon}") no-repeat 50% 50% / 20px;
  }
`;

const TasteChallengeHeader = ({ onCloseButtonClick, title, isBackButtonCross = true, className = "" }) => (
  <StyledTasteChallengeHeader className={className}>
    <TasteChallengeHeaderBtnBack
      ghost
      noBorder
      onClick={() => onCloseButtonClick()}
      closeIcon={isBackButtonCross ? iconCancel : backIcon}
    />
    <Title tag={5} uppercase center>
      {title}
    </Title>
  </StyledTasteChallengeHeader>
);

TasteChallengeHeader.propTypes = {
  onCloseButtonClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  isBackButtonCross: PropTypes.bool,
  className: PropTypes.string,
};

export default withRouter(TasteChallengeHeader);
